import { getErrorCode } from './errorUtils'

/**
 * Token/Identity Toolkit failures where we should not reinterpret missing claims as
 * definitive role state (avoid treating transient outages as “user is a customer”).
 */
const TRANSIENT_FIREBASE_AUTH_TOKEN_ERROR_CODES = new Set([
  'auth/quota-exceeded',
  'auth/network-request-failed',
  'auth/internal-error',
  'auth/too-many-requests',
])

export function isTransientFirebaseAuthTokenError(reason: unknown): boolean {
  const code = getErrorCode(reason)
  return code !== undefined && TRANSIENT_FIREBASE_AUTH_TOKEN_ERROR_CODES.has(code)
}
